const sounds = {};

export default sounds;
